module.exports = __webpack_public_path__ + "img/Weapon_223.8b05b9d3.png";